(function () {
  if (window.WOSectionTracking) return;
  var states = new Map();
  var queue = [];
  var flushRequest = null;
  var generation = 0;
  var identities = null;
  var pageViewId = null;
  var audience = null;
  var countryRequest = null;
  var countryController = null;
  var consentActive = false;
  var config = {};
  var previewConnection = null;
  var previewRequested = false;
  var timer = null;
  var geometryTimer = null;
  var geometryAt = null;
  var resizePending = false;
  var mutationObserver = null;
  var suspended = false;
  var gestureTimers = new Set();
  var itemTypes = ["compare-products"];
  var entries = ["image", "cta_1", "compare_cta"];
  var destinations = ["product", "collection", "page", "internal_other", "external", "anchor", "other"];
  var pendingGesture = new WeakMap();
  var rules = {
    feature_present: [], answer_started: [], exposure: [], visible_time: ["durationMs"], control_clicked: ["control"], product_clicked: ["productId", "entry"],
    equipment_changed: ["previousProductId", "productId", "targetId", "category"], target_selected: ["targetId", "category", "productId"],
    search_submitted: ["source"], search_result: ["source", "outcome"], view_changed: ["gesture"],
    viewer_ready: ["loadDurationMs"], viewer_error: ["reason"],
    product_changed: ["column", "previousProductId", "productId", "productIds"], copy_result: ["outcome"],
  };
  function allowed() {
    try {
      return !!window.Shopify && !window.Shopify.designMode &&
        (!previewRequested || (previewConnection && previewConnection.expiresAt > Date.now())) &&
        window.Shopify.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  function getCountry() {
    return getLocation().then(function (location) { return location ? location.country : null; });
  }
  function getLocation() {
    if (!allowed()) return Promise.resolve(null);
    if (countryRequest) return countryRequest;
    var current = generation;
    var controller = new AbortController();
    countryController = controller;
    var timeout = setTimeout(function () { controller.abort(); }, 2000);
    countryRequest = window.fetch("/cdn-cgi/trace", { cache: "no-store", credentials: "omit", signal: controller.signal })
      .then(function (response) { return response.ok ? response.text() : ""; })
      .then(function (text) {
        if (current !== generation || !allowed() || controller.signal.aborted) return null;
        var country = /^loc=([A-Z]{2})\r?$/m.exec(text);
        var ip = /^ip=([0-9a-fA-F:.]{2,45})\r?$/m.exec(text);
        return { country: country && country[1] !== "XX" ? country[1] : null, ip: ip ? ip[1] : null };
      })
      .catch(function () { return null; })
      .finally(function () {
        clearTimeout(timeout);
        if (countryController === controller) countryController = null;
      });
    return countryRequest;
  }
  async function sendGuideEvent(payload) {
    if (!allowed()) return;
    var connection = previewConnection;
    var response = await window.fetch(connection ? connection.endpoint.replace(/\/section-events$/, "/guide-events") : "/apps/bg-analytics/api/proxy/events", {
      method: "POST", keepalive: true,
      headers: Object.assign({ "Content-Type": "application/json" }, connection ? { Authorization: "Bearer " + connection.token } : {}),
      credentials: connection ? "omit" : "same-origin", body: JSON.stringify(payload),
    });
    if (connection && [401, 403, 404].includes(response.status)) {
      disablePreview();
      revoke();
    }
    return response;
  }
  function uuid() { return window.crypto.randomUUID(); }
  function storage(store, key, value) {
    try {
      if (value === null) store.removeItem(key);
      else if (value !== undefined) store.setItem(key, JSON.stringify(value));
      else return JSON.parse(store.getItem(key) || "null");
    } catch (_) { return null; }
  }
  function configurePreview() {
    try {
      var fragment = new URLSearchParams((window.location.hash || "").slice(1));
      var raw = fragment.get("wo-section-dev");
      if (raw) {
        previewRequested = true;
        fragment.delete("wo-section-dev");
        window.history.replaceState(null, "", window.location.pathname + window.location.search + (fragment.size ? "#" + fragment.toString() : ""));
      }
      if (window.Shopify?.theme?.role !== "development") {
        storage(window.sessionStorage, "wo-section-development-v1", null);
        return;
      }
      var connection = raw ? JSON.parse(raw) : storage(window.sessionStorage, "wo-section-development-v1");
      if (!connection) return;
      previewRequested = true;
      if (connection.shopDomain !== window.Shopify.shop ||
        !/^https:\/\/[a-z0-9-]+\.trycloudflare\.com\/api\/dev\/section-events$/.test(connection.endpoint) ||
        !/^\d{13}\.[A-Za-z0-9_-]{43}$/.test(connection.token) ||
        !Number.isFinite(connection.expiresAt) || connection.expiresAt <= Date.now() ||
        connection.expiresAt > Date.now() + 3600000 ||
        (connection.themeId && connection.themeId !== String(window.Shopify.theme.id))) {
        disablePreview();
        return;
      }
      previewConnection = connection;
      connection.themeId = String(window.Shopify.theme.id);
      storage(window.sessionStorage, "wo-section-development-v1", connection);
    } catch (_) { disablePreview(); }
  }
  function disablePreview() {
    previewRequested = true;
    previewConnection = null;
    storage(window.sessionStorage, "wo-section-development-v1", { disabled: true, themeId: String(window.Shopify?.theme?.id) });
  }
  function identify() {
    var now = Date.now();
    if (!identities) {
      var visitor = storage(window.localStorage, "wo-section-visitor-v1");
      if (!visitor || visitor.expires < now || typeof visitor.id !== "string") {
        visitor = { id: uuid(), expires: now + 90 * 86400000 };
        storage(window.localStorage, "wo-section-visitor-v1", visitor);
      }
      identities = { visitorId: visitor.id };
      pageViewId = uuid();
    }
    var visit = storage(window.sessionStorage, "wo-section-visit-v1");
    if (!visit || visit.expires < now || typeof visit.id !== "string") visit = { id: uuid() };
    visit.expires = now + 1800000;
    storage(window.sessionStorage, "wo-section-visit-v1", visit);
    identities.visitId = visit.id;
    return identities;
  }
  function revoke() {
    generation++;
    countryController?.abort();
    countryController = null;
    countryRequest = null;
    cancelGeometry();
    gestureTimers.forEach(clearTimeout);
    gestureTimers.clear();
    pendingGesture = new WeakMap();
    queue = [];
    identities = null;
    pageViewId = null;
    audience = null;
    storage(window.localStorage, "wo-section-visitor-v1", null);
    storage(window.sessionStorage, "wo-section-visit-v1", null);
    states.forEach(function (state) {
      if (state.items) {
        state.items.forEach(function (item) {
          clearTimeout(item.exposureTimer);
          item.started = null;
          item.coveredUntil = null;
          item.duration = 0;
          item.exposed = false;
        });
        state.intervals = [];
      }
      clearTimeout(state.exposureTimer);
      state.started = null;
      state.duration = 0;
      state.exposed = false;
      state.present = false;
    });
  }
  function safeToken(value) { return typeof value === "string" && /^[A-Za-z0-9_-]{1,200}$/.test(value); }
  function productId(value) { return typeof value === "string" && /^[1-9]\d{0,19}$/.test(value); }
  function audienceContext() {
    if (audience || document.hidden || suspended || !allowed()) return audience;
    try {
      var nav = window.navigator || {};
      var ua = typeof nav.userAgent === "string" ? nav.userAgent : "";
      var tablet = /iPad|tablet|Kindle|PlayBook|Silk\/|Android(?!.*Mobile)/i.test(ua);
      var os = /iPhone|iPad|iPod/i.test(ua) ? "iOS" :
        /Windows/i.test(ua) ? "Windows" : /Android/i.test(ua) ? "Android" : /Mac OS X|Macintosh/i.test(ua) ? "macOS" :
        /Linux/i.test(ua) ? "Linux" : /CrOS|FreeBSD|OpenBSD|NetBSD|webOS|BlackBerry|BB10/i.test(ua) ? "Other" : "Unknown";
      var browser = /Edg\/|EdgA\/|EdgiOS\//i.test(ua) ? "Edge" : /OPR\/|Opera|OPiOS\//i.test(ua) ? "Opera" :
        /SamsungBrowser/i.test(ua) ? "Samsung Internet" : /Chrome\/|CriOS\//i.test(ua) ? "Chrome" :
        /Firefox|FxiOS\//i.test(ua) ? "Firefox" : /Safari\//i.test(ua) ? "Safari" : /Mozilla\//i.test(ua) ? "Other" : "Unknown";
      audience = {
        deviceType: tablet ? "Tablet" : /Mobile|iPhone|iPod|webOS/i.test(ua) ? "Mobile" :
          /Windows NT|Macintosh|Mac OS X|X11|CrOS|Linux/i.test(ua) ? "Desktop" : "Unknown",
        browser: browser, os: os,
      };
      if (typeof nav.language === "string" && nav.language.length <= 64) audience.locale = nav.language;
      return audience;
    } catch (_) { return null; }
  }
  function itemParameters(eventName, parameters) {
    var selected = {};
    if (eventName === "exposure" || eventName === "feature_present") return Object.keys(parameters).length ? null : selected;
    if (eventName === "visible_time" || eventName === "item_visible_time") {
      if (!Number.isInteger(parameters.durationMs) || parameters.durationMs < 0 || parameters.durationMs > 86400000) return null;
      selected.durationMs = parameters.durationMs;
    }
    if (eventName === "link_clicked") {
      if (!entries.includes(parameters.entry) || !destinations.includes(parameters.destinationType)) return null;
      if (parameters.productId !== undefined && parameters.destinationType !== "product") return null;
      selected.entry = parameters.entry;
      selected.destinationType = parameters.destinationType;
      if (parameters.entry === "compare_cta") {
        if (parameters.itemId !== undefined || parameters.identityMode !== undefined || parameters.productId !== undefined) return null;
      }
    }
    if (eventName === "item_exposure" || eventName === "item_visible_time" || (eventName === "link_clicked" && parameters.entry !== "compare_cta")) {
      if (!safeToken(parameters.itemId) || !["source", "render_position"].includes(parameters.identityMode)) return null;
      selected.itemId = parameters.itemId;
      selected.identityMode = parameters.identityMode;
      if (parameters.productId !== undefined) {
        if (!productId(parameters.productId)) return null;
        selected.productId = parameters.productId;
      }
    }
    return selected;
  }
  function track(element, eventName, parameters) {
    try {
      if (!allowed()) return;
      var root = element.closest("[data-wo-track-section]");
      if (!root) return;
      var isItemType = itemTypes.includes(root.dataset.woTrackSection);
      if (root.dataset.woTrackSection === "buying-guide") {
        if (!["feature_present", "exposure", "answer_started"].includes(eventName) || Object.keys(parameters || {}).length) return;
      } else if (isItemType ? !["feature_present", "exposure", "visible_time", "item_exposure", "item_visible_time", "link_clicked"].includes(eventName) :
        !["skyviewer", "compare-products-custom"].includes(root.dataset.woTrackSection) || !Object.hasOwn(rules, eventName) || eventName === "answer_started") return;
      if (eventName === "product_clicked" && root.dataset.woTrackSection !== "compare-products-custom") return;
      var selected = {};
      parameters = parameters || {};
      if (isItemType) {
        selected = itemParameters(eventName, parameters);
        if (!selected) return;
      } else rules[eventName].forEach(function (key) { selected[key] = parameters[key]; });
      var ids = identify();
      var payload = {
        eventId: uuid(), visitorId: ids.visitorId, visitId: ids.visitId, pageViewId: pageViewId,
        pagePath: window.location.pathname, pageType: config.pageType || "page", resourceId: config.resourceId || null,
        sectionType: root.dataset.woTrackSection, sectionId: root.dataset.sectionId,
        eventName: eventName, parameters: selected, occurredAt: new Date().toISOString(),
      };
      if (eventName !== "feature_present" && ["skyviewer", "compare-products-custom", "compare-products"].includes(payload.sectionType)) {
        var context = audienceContext();
        if (context) payload.context = context;
      }
      if (queue.length >= 100) queue.shift();
      queue.push({ payload: payload, attempts: 0 });
      if (eventName !== "feature_present") root.dispatchEvent(new CustomEvent("wo:section:interaction", {
        bubbles: true, detail: { sectionId: payload.sectionId, eventName: eventName, parameters: selected },
      }));
      if (queue.length >= 20) flush();
    } catch (_) {}
  }
  function flush() {
    if (flushRequest) return flushRequest;
    if (!queue.length && allowed()) return Promise.resolve();
    flushRequest = flushBatch().finally(function () { flushRequest = null; });
    return flushRequest;
  }
  async function flushBatch() {
    if (!allowed()) { if (consentActive) { consentActive = false; revoke(); } return; }
    if (!queue.length) return;
    var endpoint = previewConnection ? previewConnection.endpoint : config.endpoint || "/apps/bg-analytics/api/proxy/section-events";
    if (!previewConnection && !/^\/apps\/[a-zA-Z0-9_/-]+$/.test(endpoint)) return;
    var current = generation;
    var country = await getCountry();
    if (current !== generation || !allowed() || !queue.length) return;
    var firstVisit = queue[0].payload.visitId;
    var batch = [];
    while (queue.length && batch.length < 20 && queue[0].payload.visitId === firstVisit) {
      if (queue[0].payload.context && !Object.hasOwn(queue[0].payload.context, "country")) {
        queue[0].payload.context = Object.assign({}, queue[0].payload.context, { country: country });
      }
      var candidate = batch.concat(queue[0]);
      if (new TextEncoder().encode(JSON.stringify(candidate.map(function (item) { return item.payload; }))).length > 32768) {
        if (!batch.length) queue.shift();
        break;
      }
      batch.push(queue.shift());
    }
    if (!batch.length) return;
    try {
      var response = await window.fetch(endpoint, {
        method: "POST", headers: Object.assign({ "Content-Type": "application/json" }, previewConnection ? { Authorization: "Bearer " + previewConnection.token } : {}),
        credentials: previewConnection ? "omit" : "same-origin", keepalive: true,
        body: JSON.stringify(batch.map(function (item) { return item.payload; })),
      });
      if (previewConnection && (response.status === 401 || response.status === 403 || response.status === 404)) {
        disablePreview();
        revoke();
      }
      if (!response.ok && (response.status === 429 || response.status >= 500)) throw new Error("retry");
    } catch (_) {
      if (current === generation && allowed()) {
        batch.forEach(function (item) { item.attempts++; });
        queue = batch.filter(function (item) { return item.attempts < 3; }).concat(queue).slice(0, 100);
      }
    }
  }
  function pause(state) {
    clearTimeout(state.exposureTimer);
    if (state.started === null) return;
    state.duration += Math.max(0, performance.now() - state.started);
    state.started = null;
    if (state.exposed) track(state.root, "visible_time", { durationMs: Math.min(86400000, Math.round(state.duration)) });
  }
  function resume(state) {
    if (states.get(state.root) !== state || suspended || !allowed() || document.hidden || !state.visible || state.started !== null ||
      !geometry(state.target, { rects: new Map(), styles: new Map() })) return;
    state.started = performance.now();
    if (!state.exposed) state.exposureTimer = setTimeout(function qualifyExposure() {
      state.exposureTimer = null;
      if (geometryAt !== null) refreshGeometry();
      if (states.get(state.root) !== state || suspended || !allowed() || document.hidden || !state.visible || state.started === null) return;
      if (!geometry(state.target, { rects: new Map(), styles: new Map() })) { pause(state); return; }
      var remaining = 1000 - (performance.now() - state.started);
      if (remaining > 0) { state.exposureTimer = setTimeout(qualifyExposure, Math.max(1, remaining)); return; }
      state.exposed = true;
      track(state.root, "exposure", {});
    }, 1000);
  }
  function rectangle(target, cache) {
    if (!cache.rects.has(target)) cache.rects.set(target, target.getBoundingClientRect());
    return cache.rects.get(target);
  }
  function geometry(target, cache) {
    if (target.isConnected === false) return false;
    var rect = rectangle(target, cache);
    var viewportWidth = document.documentElement.clientWidth || window.innerWidth;
    var viewportHeight = document.documentElement.clientHeight || window.innerHeight;
    if (!(rect.width > 0 && rect.height > 0 && viewportWidth > 0 && viewportHeight > 0)) return false;
    var left = Math.max(0, rect.left), right = Math.min(viewportWidth, rect.right);
    var top = Math.max(0, rect.top), bottom = Math.min(viewportHeight, rect.bottom);
    for (var ancestor = target; ancestor; ancestor = ancestor.parentElement) {
      if (!cache.styles.has(ancestor)) cache.styles.set(ancestor, window.getComputedStyle(ancestor));
      var css = cache.styles.get(ancestor);
      if (css.display === "none" || ["hidden", "collapse"].includes(css.visibility) || Number(css.opacity) === 0 || css.contentVisibility === "hidden") return false;
      if ([css.maskImage, css.webkitMaskImage].some(function (mask) { return mask && mask !== "none"; })) return false;
      if (css.clip && css.clip !== "auto") return false;
      if (css.clipPath && css.clipPath !== "none") {
        var inset = /^inset\(\s*([-\d.%px\s]+)\s*\)$/.exec(css.clipPath);
        if (!inset) return false;
        var parts = inset[1].trim().split(/\s+/);
        if (parts.length > 4 || parts.some(function (part) { return !/^-?(?:\d+(?:\.\d+)?|\.\d+)(px|%)?$/.test(part); })) return false;
        var clipBounds = rectangle(ancestor, cache);
        var offsets = [parts[0], parts[1] || parts[0], parts[2] || parts[0], parts[3] || parts[1] || parts[0]].map(function (part, index) {
          return parseFloat(part) * (part.endsWith("%") ? (index % 2 ? clipBounds.width : clipBounds.height) / 100 : 1);
        });
        left = Math.max(left, clipBounds.left + offsets[3]);
        right = Math.min(right, clipBounds.right - offsets[1]);
        top = Math.max(top, clipBounds.top + offsets[0]);
        bottom = Math.min(bottom, clipBounds.bottom - offsets[2]);
      }
      if (ancestor !== target && (/^(auto|scroll|hidden|clip)$/.test(css.overflowX) || /^(auto|scroll|hidden|clip)$/.test(css.overflowY))) {
        var bounds = rectangle(ancestor, cache);
        var scaleX = ancestor.offsetWidth ? bounds.width / ancestor.offsetWidth : 1;
        var scaleY = ancestor.offsetHeight ? bounds.height / ancestor.offsetHeight : 1;
        var clipLeft = bounds.left + (ancestor.clientLeft || 0) * scaleX;
        var clipTop = bounds.top + (ancestor.clientTop || 0) * scaleY;
        if (/^(auto|scroll|hidden|clip)$/.test(css.overflowX)) {
          left = Math.max(left, clipLeft);
          right = Math.min(right, clipLeft + ancestor.clientWidth * scaleX);
        }
        if (/^(auto|scroll|hidden|clip)$/.test(css.overflowY)) {
          top = Math.max(top, clipTop);
          bottom = Math.min(bottom, clipTop + ancestor.clientHeight * scaleY);
        }
      }
    }
    return Math.max(0, right - left) * Math.max(0, bottom - top) >= 0.5 * Math.min(rect.width, viewportWidth) * Math.min(rect.height, viewportHeight);
  }
  function metadata(item) {
    var parameters = { itemId: item.id, identityMode: item.identityMode };
    var data = item.target.dataset;
    if (productId(data.woTrackProductId)) parameters.productId = data.woTrackProductId;
    return parameters;
  }
  function cover(state, start, end) {
    if (start >= end) return;
    var merged = [], interval = [start, end];
    state.intervals.forEach(function (previous) {
      if (previous[1] < interval[0]) merged.push(previous);
      else if (previous[0] > interval[1]) { merged.push(interval); interval = previous; }
      else interval = [Math.min(previous[0], interval[0]), Math.max(previous[1], interval[1])];
    });
    merged.push(interval);
    state.intervals = merged;
  }
  function compactIntervals(state, now) {
    // Pending first seconds may still qualify and retroactively overlap this coverage.
    var cutoff = now;
    state.items.forEach(function (item) {
      if (!item.exposed && item.started !== null) cutoff = Math.min(cutoff, item.started);
    });
    state.intervals = state.intervals.filter(function (interval) {
      state.duration += Math.max(0, Math.min(interval[1], cutoff) - interval[0]);
      interval[0] = Math.max(interval[0], cutoff);
      return interval[1] > interval[0];
    });
  }
  function reportItems(state, emit, now) {
    if (now === undefined) now = performance.now();
    state.items.forEach(function (item) {
      if (item.exposed && item.started !== null) {
        cover(state, item.coveredUntil === null ? item.started : item.coveredUntil, now);
        item.coveredUntil = now;
        if (emit) track(state.root, "item_visible_time", Object.assign(metadata(item), { durationMs: Math.min(86400000, Math.round(item.duration + now - item.started)) }));
      }
    });
    compactIntervals(state, now);
    if (emit && state.exposed) track(state.root, "visible_time", {
      durationMs: Math.min(86400000, Math.round(state.intervals.reduce(function (total, interval) { return total + interval[1] - interval[0]; }, state.duration))),
    });
  }
  function stopItem(state, item, now) {
    clearTimeout(item.exposureTimer);
    item.exposureTimer = null;
    if (item.started !== null && item.exposed) {
      if (now === undefined) now = performance.now();
      cover(state, item.coveredUntil === null ? item.started : item.coveredUntil, now);
      item.duration += Math.max(0, now - item.started);
      track(state.root, "item_visible_time", Object.assign(metadata(item), { durationMs: Math.min(86400000, Math.round(item.duration)) }));
    }
    item.started = null;
    item.coveredUntil = null;
  }
  function updateItems(state, cache, now) {
    if (states.get(state.root) !== state) return;
    if (now === undefined) now = performance.now();
    cache = cache || { rects: new Map(), styles: new Map() };
    var active = !suspended && allowed() && !document.hidden;
    var stopped = false;
    state.items.forEach(function (item) {
      var visible = active && state.candidates.has(item) && geometry(item.target, cache);
      if (!visible) {
        if (item.started !== null) { stopItem(state, item, now); stopped = true; }
        return;
      }
      if (item.started !== null) return;
      item.started = now;
      if (!item.exposed) item.exposureTimer = setTimeout(function qualifyExposure() {
        item.exposureTimer = null;
        if (geometryAt !== null) refreshGeometry();
        if (suspended || !allowed() || document.hidden || states.get(state.root) !== state || item.started === null) return;
        if (!state.candidates.has(item) || !geometry(item.target, { rects: new Map(), styles: new Map() })) { updateItems(state); return; }
        var remaining = 1000 - (performance.now() - item.started);
        if (remaining > 0) { item.exposureTimer = setTimeout(qualifyExposure, Math.max(1, remaining)); return; }
        item.exposed = true;
        track(state.root, "item_exposure", metadata(item));
        if (!state.exposed) { state.exposed = true; track(state.root, "exposure", {}); }
        reportItems(state, false);
      }, Math.max(0, 1000 - (performance.now() - now)));
    });
    if (stopped) reportItems(state, true, now);
  }
  function observeItem(state, item, cache) {
    if (!window.IntersectionObserver) return;
    var rect = rectangle(item.target, cache);
    var width = document.documentElement.clientWidth || window.innerWidth;
    var height = document.documentElement.clientHeight || window.innerHeight;
    var threshold = rect.width > 0 && rect.height > 0 ? 0.5 * Math.min(rect.width, width) * Math.min(rect.height, height) / (rect.width * rect.height) : 0;
    if (threshold === item.threshold && item.observer) return;
    item.observer?.disconnect();
    item.threshold = threshold;
    var observer = new IntersectionObserver(function (entries) {
      if (states.get(state.root) !== state || item.observer !== observer || suspended) return;
      if (entries[0].isIntersecting || entries[0].intersectionRatio > 0) state.candidates.add(item);
      else state.candidates.delete(item);
      scheduleGeometry();
    }, { threshold: [0, threshold] });
    item.observer = observer;
    item.observer.observe(item.target);
  }
  function observeGuide(state, cache) {
    if (!window.IntersectionObserver) return;
    var rect = rectangle(state.target, cache);
    var width = document.documentElement.clientWidth || window.innerWidth;
    var height = document.documentElement.clientHeight || window.innerHeight;
    var threshold = rect.width > 0 && rect.height > 0 ? 0.5 * Math.min(rect.width, width) * Math.min(rect.height, height) / (rect.width * rect.height) : 0;
    if (threshold === state.threshold && state.observer) return;
    state.observer?.disconnect();
    state.threshold = threshold;
    var observer = new IntersectionObserver(function (entries) {
      if (states.get(state.root) !== state || state.observer !== observer || suspended) return;
      state.visible = entries[0].intersectionRatio > 0 && entries[0].intersectionRatio >= threshold;
      if (state.visible) resume(state); else pause(state);
    }, { threshold: [0, threshold] });
    state.observer = observer;
    observer.observe(state.target);
  }
  function cancelGeometry() {
    clearTimeout(geometryTimer);
    geometryTimer = null;
    geometryAt = null;
    resizePending = false;
  }
  function scheduleGeometry(resize) {
    if (suspended || !allowed() || document.hidden) return;
    resizePending = resizePending || resize === true;
    if (geometryAt !== null) return;
    geometryAt = performance.now();
    geometryTimer = setTimeout(refreshGeometry, 0);
  }
  function refreshGeometry() {
    var now = geometryAt === null ? performance.now() : geometryAt;
    var resize = resizePending;
    cancelGeometry();
    if (suspended || !allowed() || document.hidden) return;
    var cache = { rects: new Map(), styles: new Map() };
    states.forEach(function (state) {
      if (state.items) {
        state.items.forEach(function (item) { if (resize || !item.observer) observeItem(state, item, cache); });
        updateItems(state, cache, now);
      } else {
        if (state.root.dataset.woTrackSection === "buying-guide") {
          if (resize || !state.observer) observeGuide(state, cache);
          state.visible = geometry(state.target, cache);
        }
        if (state.visible && geometry(state.target, cache)) resume(state);
        else pause(state);
      }
    });
  }
  function stopState(state) {
    if (!state.items) { pause(state); return; }
    state.items.forEach(function (item) { stopItem(state, item); });
    reportItems(state, true);
  }
  function present(state) {
    if (state.present || !allowed() || suspended) return;
    state.present = true;
    track(state.root, "feature_present", {});
  }
  function updateConsent() {
    var next = allowed();
    if (next === consentActive) return;
    if (!next && consentActive) revoke();
    consentActive = next;
    states.forEach(function (state) {
      if (next) present(state);
      if (state.items) {
        if (next) state.items.forEach(function (item) { state.candidates.add(item); });
        else updateItems(state);
      }
      else if (next) resume(state); else pause(state);
    });
    if (next) { resizePending = true; refreshGeometry(); }
  }
  function register(scope) {
    var roots = Array.from(scope.querySelectorAll("[data-wo-track-section]"));
    if (scope.matches?.("[data-wo-track-section]")) roots.unshift(scope);
    roots.forEach(function (root) {
      if (states.has(root) || !["buying-guide", "skyviewer", "compare-products-custom", "compare-products"].includes(root.dataset.woTrackSection)) return;
      var target = root.querySelector("[data-wo-track-viewport]") || root;
      var state = { root: root, target: target, present: false, visible: false, started: null, duration: 0, exposed: false, exposureTimer: null, observer: null };
      present(state);
      if (itemTypes.includes(root.dataset.woTrackSection)) {
        state.intervals = [];
        state.items = [];
        state.candidates = new Set();
        var elements = Array.from(root.querySelectorAll("[data-wo-track-item]")).filter(function (element) {
          return element.closest("[data-wo-track-section]") === root;
        });
        elements.forEach(function (element) {
          var data = element.dataset, id = data.woTrackItem, mode = data.woTrackIdentity;
          if (!safeToken(id) || !["source", "render_position"].includes(mode) || state.items.some(function (item) { return item.id === id; })) return;
          state.items.push({ target: element, id: id, identityMode: mode, started: null, coveredUntil: null, duration: 0, exposed: false, exposureTimer: null });
        });
        state.resizeObserver = window.ResizeObserver ? new window.ResizeObserver(function () { scheduleGeometry(true); }) : null;
        state.items.forEach(function (item) {
          state.candidates.add(item);
          for (var ancestor = item.target; ancestor; ancestor = ancestor.parentElement) state.resizeObserver?.observe(ancestor);
        });
        states.set(root, state);
        scheduleGeometry(true);
        return;
      }
      if (root.dataset.woTrackSection === "buying-guide") {
        states.set(root, state);
        state.resizeObserver = window.ResizeObserver ? new window.ResizeObserver(function () { scheduleGeometry(true); }) : null;
        state.resizeObserver?.observe(target);
        observeGuide(state, { rects: new Map(), styles: new Map() });
        scheduleGeometry(true);
        return;
      }
      if (window.IntersectionObserver) {
        state.observer = new IntersectionObserver(function (entries) {
          if (states.get(root) !== state || suspended) return;
          state.visible = entries[0].intersectionRatio >= 0.5;
          if (state.visible) resume(state); else pause(state);
        }, { threshold: [0, 0.5] });
        state.observer.observe(target);
      }
      states.set(root, state);
    });
  }
  function click(event) {
    if ((event.type === "click" && event.button !== 0) || (event.type === "auxclick" && event.button !== 1)) return;
    var root = event.target.closest?.("[data-wo-track-section]");
    if (!root) return;
    if (itemTypes.includes(root.dataset.woTrackSection)) {
      var link = event.target.closest("a[data-wo-track-entry][href]");
      if (!link || link.closest("[data-wo-track-section]") !== root || link.closest('[disabled], [aria-disabled="true"]')) return;
      var entry = link.dataset.woTrackEntry;
      if (!entries.includes(entry)) return;
      var href = link.getAttribute("href");
      if (!href || !href.trim()) return;
      var destinationType;
      try {
        var url = new URL(href, window.location.href);
        var routeRoot = window.Shopify?.routes?.root || "/";
        var path = url.pathname.startsWith(routeRoot) ? "/" + url.pathname.slice(routeRoot.length) : url.pathname;
        destinationType = href.trim().startsWith("#") ? "anchor" : !["https:", "http:"].includes(url.protocol) ? "other" :
          url.origin !== window.location.origin ? "external" : /^\/products\//.test(path) || /^\/collections\/[^/]+\/products\//.test(path) ? "product" :
          /^\/collections(?:\/|$)/.test(path) ? "collection" : /^\/pages\//.test(path) ? "page" : "internal_other";
      } catch (_) { return; }
      var parameters = { entry: entry, destinationType: destinationType };
      if (entry !== "compare_cta") {
        var target = link.closest("[data-wo-track-item]");
        var item = states.get(root)?.items?.find(function (candidate) { return candidate.target === target; });
        if (!item) return;
        parameters = Object.assign(metadata(item), parameters);
        delete parameters.productId;
        if (destinationType === "product" && productId(link.dataset.woTrackProductId) && link.dataset.woTrackProductUrl) {
          try {
            var productUrl = new URL(link.dataset.woTrackProductUrl, window.location.href);
            if (productUrl.origin === url.origin && productUrl.pathname === url.pathname) parameters.productId = link.dataset.woTrackProductId;
          } catch (_) {}
        }
      }
      track(root, "link_clicked", parameters);
      flush();
      return;
    }
    var product = event.target.closest("[data-wo-track-product]");
    if (product && root.dataset.woTrackSection === "compare-products-custom") {
      track(root, "product_clicked", { productId: product.dataset.woTrackProduct, entry: product.dataset.woTrackEntry });
      flush();
      return;
    }
    if (event.type === "auxclick") return;
    var control = event.target.closest("[data-wo-track-control]");
    var name = control?.dataset.woTrackControl;
    if (!name && root.dataset.woTrackSection === "skyviewer") {
      if (event.target.closest("[data-suggest-cat]")) name = "category_" + event.target.closest("[data-suggest-cat]").dataset.suggestCat;
      else if (event.target.closest("[data-index], [data-catalog-name]")) name = "suggestion";
    }
    if (name) track(root, "control_clicked", { control: name });
    if (name === "pdf" || name === "share" || product) flush();
  }
  function submit(event) {
    if (!event.target.matches("[data-wo-skyviewer-search]")) return;
    var root = event.target.closest("[data-wo-track-section]");
    if (event.target.querySelector("input")?.value.trim()) track(root, "search_submitted", { source: "typed" });
  }
  function manualView(element, gesture, phase, snapshot) {
    if (!snapshot || !allowed() || document.hidden || suspended) return;
    var pending = pendingGesture.get(element) || {};
    if (phase === "start") {
      if (!pending[gesture]) pending[gesture] = { start: snapshot, timer: null };
    } else if (pending[gesture]) {
      var item = pending[gesture];
      var current = generation;
      clearTimeout(item.timer);
      gestureTimers.delete(item.timer);
      item.timer = setTimeout(function () {
        gestureTimers.delete(item.timer);
        delete pending[gesture];
        if (current === generation && !document.hidden && !suspended && JSON.stringify(item.start) !== JSON.stringify(snapshot)) track(element, "view_changed", { gesture: gesture });
      }, gesture === "zoom" ? 300 : 0);
      gestureTimers.add(item.timer);
    }
    pendingGesture.set(element, pending);
  }
  function init() {
    try { config = JSON.parse(document.getElementById("wo-section-tracking-config")?.textContent || "{}"); } catch (_) {}
    register(document);
    if (!allowed()) revoke();
    updateConsent();
    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === "function") {
      try { window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], updateConsent); } catch (_) {}
    }
    clearInterval(timer);
    if (!mutationObserver && window.MutationObserver) {
      mutationObserver = new window.MutationObserver(function (records) {
        if (suspended || !allowed() || document.hidden) return;
        var relevant = records.some(function (record) {
          return Array.from(states.values()).some(function (state) {
            return state.items ? state.items.some(function (item) { return record.target === item.target || record.target.contains(item.target); }) :
              record.target === state.target || record.target.contains(state.target);
          });
        });
        if (relevant) scheduleGeometry(true);
      });
    }
    mutationObserver?.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ["class", "style", "hidden", "aria-hidden"] });
    timer = setInterval(function () {
      updateConsent();
      if (geometryAt !== null) refreshGeometry();
      states.forEach(function (state) {
        if (state.items) reportItems(state, true);
        else if (state.started !== null && state.exposed) {
          track(state.root, "visible_time", { durationMs: Math.min(86400000, Math.round(state.duration + performance.now() - state.started)) });
        }
      });
      flush();
    }, 5000);
  }
  configurePreview();
  window.WOSectionTracking = { track: track, flush: flush, manualView: manualView, getCountry: getCountry, getLocation: getLocation, sendGuideEvent: sendGuideEvent };
  document.addEventListener("click", click, true);
  document.addEventListener("auxclick", click, true);
  document.addEventListener("submit", submit, true);
  document.addEventListener("visitorConsentCollected", updateConsent);
  document.addEventListener("visibilitychange", function () {
    cancelGeometry();
    if (document.hidden) {
      gestureTimers.forEach(clearTimeout); gestureTimers.clear(); pendingGesture = new WeakMap();
    }
    states.forEach(function (state) {
      if (state.items) { if (document.hidden) updateItems(state); }
      else if (document.hidden) pause(state); else resume(state);
    });
    if (!document.hidden) { resizePending = true; refreshGeometry(); }
    if (document.hidden) flush();
  });
  document.addEventListener("shopify:section:load", function (event) { register(event.target); });
  document.addEventListener("shopify:section:unload", function (event) {
    gestureTimers.forEach(clearTimeout); gestureTimers.clear(); pendingGesture = new WeakMap();
    states.forEach(function (state, root) {
      if (event.target.contains(root)) {
        stopState(state); state.observer?.disconnect(); state.resizeObserver?.disconnect();
        state.items?.forEach(function (item) { item.observer?.disconnect(); });
        states.delete(root);
      }
    });
  });
  document.addEventListener("scroll", scheduleGeometry, true);
  window.addEventListener("resize", function () { scheduleGeometry(true); });
  window.addEventListener("pagehide", function () {
    suspended = true;
    gestureTimers.forEach(clearTimeout); gestureTimers.clear(); pendingGesture = new WeakMap();
    cancelGeometry();
    states.forEach(stopState); flush(); clearInterval(timer);
    mutationObserver?.disconnect();
    states.forEach(function (state) {
      state.observer?.disconnect(); state.resizeObserver?.disconnect();
      state.items?.forEach(function (item) { item.observer?.disconnect(); });
    });
  });
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      suspended = false;
      states.forEach(function (state) {
        if (state.items) {
          state.items.forEach(function (item) {
            item.observer?.observe(item.target);
            for (var ancestor = item.target; ancestor; ancestor = ancestor.parentElement) state.resizeObserver?.observe(ancestor);
          });
        } else {
          state.visible = false;
          state.observer?.observe(state.root.querySelector("[data-wo-track-viewport]") || state.root);
          state.resizeObserver?.observe(state.target);
        }
      });
      init();
      resizePending = true;
      refreshGeometry();
    }
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();